export const numberFormat = (v: number = 0, minDigits = 2, maxDigits = 2) => {
	return v.toLocaleString(undefined, {
		minimumFractionDigits: minDigits,
		maximumFractionDigits: maxDigits,
	})
}
